import http from './_http'

const WebCastle = (m) => { return http.post(`/webcastle`, m); }
const WebCastle_Call = (a, b, c) => WebCastle({target: a, cmd : b, body: c});
const WebCastleLatest = (branch='release') => { return http.get(`/${branch}/latest/webcastle`); }
const WebCastleDBLatest = (branch='release') => { return http.get(`/${branch}/latest/mmdb`); }

const webcaslte = { WebCastle, WebCastle_Call, WebCastleLatest, WebCastleDBLatest }


export default webcaslte
export { WebCastle, WebCastle_Call, WebCastleLatest, WebCastleDBLatest }
